import { Box, Stack, Typography } from "@mui/material";
import PropTypes from "prop-types";

function FormTitle({ title, actions }) {
  return (
    <Stack
      direction="row"
      sx={{
        justifyContent: "space-between",
        alignItems: "center",
        height: 36,
      }}
    >
      <Typography variant="h5" component="h3" sx={{ m: 0 }}>
        {title}
      </Typography>
      {!!actions && <Box>{actions}</Box>}
    </Stack>
  );
}

FormTitle.propTypes = {
  title: PropTypes.string,
  actions: PropTypes.node,
};

export default FormTitle;
